// fetch wrapper with KOMOJU authentication already handled.
export function komojuFetch(
  config: {
    komojuApi: string,
    publishableKey: string | null,
  },
  method: 'GET' | 'POST',
  path: string,
  body?: object
): Promise<Response> {
  if (!config.komojuApi) throw new Error('KOMOJU API URL is null');
  if (!config.publishableKey) throw new Error('KOMOJU publishable-key not set');

  return fetch(`${config.komojuApi}${path}`, {
    method,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      authorization: `Basic ${btoa(`${config.publishableKey}:`)}`,
      'komoju-via': 'fields',
    },
    body: body ? JSON.stringify(body) : undefined
  });
}
